
  import { Mixins, Component } from 'vue-mixin-decorator';
  import StepTechYear from '@/mixins/reviews/create/step-tech-year';

  @Component
  export default class StepTechYearMobile extends Mixins<StepTechYear>(
    StepTechYear,
  ) {}
